import {
    faEye,
    faEyeSlash,
    faQrcode,
    faPencilAlt,
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
 
export function initIconFonts () {
    library.add(
        faEye,
        faEyeSlash,
        faQrcode,
        faPencilAlt,
    );
}
